var map = {
	"./000001.svg": 2960,
	"./000002.svg": 9650,
	"./000003.svg": 8966,
	"./000004.svg": 6225,
	"./000005.svg": 4924,
	"./000006.svg": 9499,
	"./000007.svg": 4596,
	"./000008.svg": 9402,
	"./000009.svg": 8539,
	"./000010.svg": 7831,
	"./000011.svg": 3831,
	"./000012.svg": 8833,
	"./000013.svg": 8399,
	"./000014.svg": 5096,
	"./000015.svg": 3062,
	"./000016.svg": 740,
	"./000099.svg": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3239;